var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Game',{attrs:{"cards":[
        "fragment",
        "every-website-http",
        "request-parts",
        "response-parts",
        "what-part-html",
        "what-part-caching",
        "what-part-redirect",
        "what-header-login",
        "request-method-get",
        "request-method-post",
        "content-type",
        "browser-view-http-request",
        "500-error",
        "js-request-limits" ],"basedir":"http","title":"HTTP flashcards"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }